import { useTheme } from '@emotion/react';
import { Box, Button, MobileStepper, Paper, Typography } from '@mui/material';
import React, { useState } from 'react';
import { autoPlay } from 'react-swipeable-views-utils';
import SwipeableViews from 'react-swipeable-views';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';


const AutoSwiper = autoPlay(SwipeableViews);


function Swiper({works, link}) {
    const images = works
    
    const theme = useTheme()

    const [activeStep, setActiveStep] = useState(0)

    const maxSteps = images.length;

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
      };
    
      const handleStepChange = (step) => {
        setActiveStep(step);
      };

    return (
        <>
            <Box sx={{ maxWidth: 400, flexGrow: 1 }}>
                <Paper 
                    square
                    elevation={0}
                    sx={{
                        justifyContent:"space-between",
                        color:"#fff",
                        display: "flex",
                        alignItems: "center",
                        height: 50,
                        padding: "0px 10px",
                        bgcolor: '#212121',
                    }}
                >
                    <Typography>{images[activeStep].label}</Typography>
                    <Button target='_blank' 
                        variant="outlined" 
                        href={link} 
                        sx={{color: "#fff", 
                        borderColor:"#fff", 
                        ":hover":{color: "black", backgroundColor:"#fff", border: "none"}}} >
                        OPEN
                    </Button>
                </Paper>
                <AutoSwiper
                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                    index={activeStep}
                    onChangeIndex={handleStepChange}
                    enableMouseEvents
                >
                    {images.map((step, index)=>(
                        <div key={index} style={{
                            margin: "0px 0px 20px 0px",
                            height: "255px",
                            overflow: "hidden",
                        }}>
                            {Math.abs(activeStep - index) <=2 ? (
                                <Box 
                                    component="img"
                                    sx={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                    }}
                                    src={step.imgPath}
                                    alt={step.label}
                                    />
                                    
                            ):null }
                        </div>
                    ))}
                </AutoSwiper>
                <MobileStepper
                    steps={maxSteps}
                    sx={{
                        bgcolor: "#212121"
                    }}
                    position="static"
                    activeStep={activeStep}
                    nextButton={
                        <Button
                            size="small"
                            onClick={handleNext}
                            disabled={activeStep === maxSteps - 1}
                            sx={{
                                color:"#fff"
                            }} >
                            Next
                            {theme.direction === "rtl" ? (
                                <KeyboardArrowLeftIcon/>
                            ) :(
                                <ArrowForwardIosIcon/>
                            )}
                        </Button>
                    }
                    backButton={
                        <Button size='small' onClick={handleBack} disabled={activeStep === 0} sx={{color:"#fff"}}>
                            {theme.direction === "rtl" ? (
                                <ArrowForwardIosIcon />
                            ):(
                                <KeyboardArrowLeftIcon />
                            )}
                            Back
                        </Button>
                    }
                />
            </Box>
        </>
    )
}

export default Swiper